<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.6913 9.73801H21.8919V9.73615M3.10938 20.463V15.2623M3.10938 15.2623L8.31004 15.2623M3.10938 15.2623L6.42281 18.5779C7.4546 19.6116 8.76404 20.3959 10.2763 20.8011C14.8607 22.0295 19.573 19.3089 20.8014 14.7244M4.19958 10.276C5.42798 5.69148 10.1403 2.97085 14.7247 4.19925C16.237 4.60446 17.5464 5.38875 18.5782 6.42248L21.8919 9.73615M21.8919 4.53738V9.73615"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgRefresh',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
